// src/pages/News.js
import React from "react";
import InfoPageLayout from "./InfoPageLayout";
import { Megaphone, Twitter, Linkedin } from "lucide-react";

const News = () => {
  return (
    <InfoPageLayout
      title="News & Updates"
      subtitle="The latest news, product updates, and insights from the Xenford team."
    >
      <div className="flex flex-col items-center text-center py-16 px-6 bg-gray-900/50 border border-dashed border-white/20 rounded-2xl">
        <Megaphone size={48} className="text-blue-400 mb-6" />
        <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
          The Ink is Still Drying.
        </h3>
        <p className="text-gray-400 max-w-xl mb-8">
          Our official blog and newsroom are launching soon. This is where we'll
          share product updates, behind-the-scenes stories, and our vision for
          the future of time management.
        </p>
        <div className="flex flex-col items-center gap-4">
          <p className="font-bold text-sm uppercase tracking-widest">
            Follow Us for Real-Time Updates:
          </p>
          <div className="flex items-center gap-6">
            <a
              // ✅ FIX: Replaced "#" with a valid placeholder URL
              href="https://twitter.com/xenford" // Or just "https://twitter.com"
              target="_blank" // Open in a new tab
              rel="noopener noreferrer" // Security best practice for new tabs
              className="text-gray-400 hover:text-white transition-colors"
              aria-label="Twitter"
            >
              <Twitter size={24} />
            </a>
            <a
              // ✅ FIX: Replaced "#" with a valid placeholder URL
              href="https://linkedin.com/company/xenford" // Or just "https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 hover:text-white transition-colors"
              aria-label="LinkedIn"
            >
              <Linkedin size={24} />
            </a>
          </div>
        </div>
      </div>
    </InfoPageLayout>
  );
};

export default News;
